<template>
  <v-app-bar app flat fixed light dense color="#F5C048">
    <v-app-bar-nav-icon
      @click="setDrawer(!drawer)"
      v-if="loggedIn && $route.name !== '404 Error'"
    />
    <v-toolbar-title>راديو زوارة</v-toolbar-title>
    <v-spacer />
    <v-btn
      text
      rounded
      v-if="loggedIn && $route.name !== '404 Error'"
      @click="onLogout"
      :loading="currentUserDataLoading"
    >
      <v-icon class="mx-1">mdi-logout</v-icon>
      تسجيل خروج
    </v-btn>
  </v-app-bar>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "AppBar",
  computed: {
    ...mapState(["drawer", "headerLinks"]),
    ...mapGetters("auth", ["currentUserDataLoading", "loggedIn"]),
  },
  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
    async onLogout() {
      await this.$store.dispatch("auth/onLogout");
      setTimeout(() => {
        if (!this.loggedIn) {
          this.$router.push({ name: "login" });
        }
      }, 1000);
    },
  },
};
</script>
